import * as React from 'react'
import { SVGProps } from 'react'

const RUNEUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <g clipPath='url(#clip0_1712_18698)'>
      <path
        d='M10 39.6368L32.0859 30.3363L25.0942 23.2466L10 39.6368ZM18.1134 16.1678L25.1051 23.2466L37.5855 8L18.1134 16.1678Z'
        fill='url(#paint0_linear_1712_18698)'
      />
    </g>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
    <defs>
      <linearGradient
        id='paint0_linear_1712_18698'
        x1='10.0005'
        y1='23.8188'
        x2='37.5817'
        y2='23.8188'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#00CCFF' />
        <stop offset='1' stopColor='#33FF99' />
      </linearGradient>
      <clipPath id='clip0_1712_18698'>
        <rect width='27.5855' height='31.6368' fill='white' transform='translate(10 8)' />
      </clipPath>
    </defs>
  </svg>
)

export default RUNEUSD
